var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14.5,
    width: 38,
    height: 36,
    rx: 2.5,
    fill: "white",
    stroke: "#9A9FB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 23H46.9683",
    stroke: "#27282A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3236 21H20V29H28.4005V26.5001M22.3077 24.3024L24.6154 26.5001L30 21.3722",
    stroke: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26.0713H42.1905",
    stroke: "#27282A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38H46.9683",
    stroke: "#27282A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3236 36H20V44H28.4005V41.5001M22.3077 39.3024L24.6154 41.5001L30 36.3722",
    stroke: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41.0713H42.1905",
    stroke: "#27282A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 9,
    fill: "white",
    stroke: "#9A9FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43.9598H43.9815V40H40V43.9598ZM41.3433 41.336H42.6382V42.6238H41.3433V41.336Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49.0001H43.9815V45.0403H40V49.0001ZM41.3433 46.3763H42.6382V47.6641H41.3433V46.3763Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0092 45.0981H45.0767V47.0202H47.0092V45.0981Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9418 47.02H47.0093V48.942H48.9418V47.02Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0186 40V43.9598H49V40H45.0186ZM47.6568 42.6238H46.3618V41.336H47.6568V42.6238Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    y1: 25,
    x2: 28.8926,
    y2: 28.1381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20,
    y1: 40,
    x2: 28.8926,
    y2: 43.1381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 40,
    y1: 41.9799,
    x2: 43.6846,
    y2: 43.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 40,
    y1: 47.0202,
    x2: 43.6846,
    y2: 48.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 45.0767,
    y1: 46.0592,
    x2: 46.8651,
    y2: 46.5668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 47.0093,
    y1: 47.981,
    x2: 48.7977,
    y2: 48.4887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 45.0186,
    y1: 41.9799,
    x2: 48.7032,
    y2: 43.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash4);
export default __webpack_public_path__ + "static/media/dash4.77d2aadde2b19b2471442113f65f8a0a.svg";
export { ForwardRef as ReactComponent };